import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";

export const CursorTrail = () => {
    const dotRef = useRef(null);
    const ringRef = useRef(null);

    useEffect(() => {
        if (window.matchMedia("(pointer: coarse)").matches) return;
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

        document.body.classList.add("has-custom-cursor");
        const dot = dotRef.current;
        const ring = ringRef.current;
        if (!dot || !ring) return;

        const xDot = gsap.quickTo(dot, "x", { duration: 0.05, ease: "none" });
        const yDot = gsap.quickTo(dot, "y", { duration: 0.05, ease: "none" });
        const xRing = gsap.quickTo(ring, "x", { duration: 0.45, ease: "power3" });
        const yRing = gsap.quickTo(ring, "y", { duration: 0.45, ease: "power3" });

        const onMove = (e) => {
            xDot(e.clientX - 4);
            yDot(e.clientY - 4);
            xRing(e.clientX - 18);
            yRing(e.clientY - 18);
        };
        window.addEventListener("mousemove", onMove);

        const onEnterInteractive = () => gsap.to(ring, { scale: 1.6, borderColor: "#FF5B3E", duration: 0.25 });
        const onLeaveInteractive = () => gsap.to(ring, { scale: 1, borderColor: "#FF5B3E", duration: 0.25 });

        const interactive = document.querySelectorAll("a, button, [role='button'], input, textarea");
        interactive.forEach((i) => {
            i.addEventListener("mouseenter", onEnterInteractive);
            i.addEventListener("mouseleave", onLeaveInteractive);
        });

        return () => {
            window.removeEventListener("mousemove", onMove);
            interactive.forEach((i) => {
                i.removeEventListener("mouseenter", onEnterInteractive);
                i.removeEventListener("mouseleave", onLeaveInteractive);
            });
            document.body.classList.remove("has-custom-cursor");
        };
    }, []);

    return (
        <>
            <div ref={dotRef} className="cursor-dot" aria-hidden="true" />
            <div ref={ringRef} className="cursor-ring" aria-hidden="true" />
        </>
    );
};
